export default (data) => Boolean(data.Id && data.MapGeometryType);
